import { useTranslation } from 'react-i18next'

import { Text, VStack } from '@enechain/ecloud-designsystem'

import {
  formatCivilSlash,
  periodText,
} from '~/pages/AdminPlantUnitMaster/models/affiliation'
import type { PlantUnitAffiliationRow } from '~/pages/AdminPlantUnitMaster/models/unitRows'

type Props = {
  /** 系統コードを持つか (無ければ所属は引けない)。 */
  hasPlantMaster: boolean
  affiliations: readonly PlantUnitAffiliationRow[]
}

/**
 * 電源ユニットの所属 BG (読み取り専用)。系統コードが所属する BG を、発電販売計画マスタの
 * 発電所情報と BG 情報から導いた期間つきで並べる。変更は発電販売計画マスタで行う。
 */
export const AffiliationSection = ({
  hasPlantMaster,
  affiliations,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const f = (key: string): string =>
    t(`page:adminPlantUnitMaster.unit.field.${key}`)
  return (
    <VStack align="stretch" gap={1}>
      <Text textStyle="caption" color="Text.midEmphasis">
        {f('affiliationBgHint')}
      </Text>
      {!hasPlantMaster ? (
        <Text textStyle="body">
          {t('page:adminPlantUnitMaster.unit.detail.noPlant')}
        </Text>
      ) : affiliations.length === 0 ? (
        <Text textStyle="body">
          {t('page:adminPlantUnitMaster.unit.detail.noAffiliation')}
        </Text>
      ) : (
        affiliations.map((a) => (
          <Text
            key={`${a.bgMasterId}:${formatCivilSlash(a.validFrom)}`}
            textStyle="body"
          >
            {`${a.bgName} (${a.bgCode})  ${periodText(a)}`}
            {!a.isOwnGenerationBg && (
              <Text
                as="span"
                marginLeft={2}
                color="Text.lowEmphasis"
                title={f('notManagedHint')}
              >
                {f('notManaged')}
              </Text>
            )}
          </Text>
        ))
      )}
    </VStack>
  )
}
